import(/* webpackMode: "eager" */ "D:\\project\\xampp\\htdocs\\Vidyalaya_LMS_Website_NEXTJS\\app\\global-error.js");
